<ziro-text fieldId="groupName" [inlineLabel]="false"></ziro-text>
<ziro-extension-ranges fieldId="dnRanges"></ziro-extension-ranges>
<ziro-textarea fieldId="exceptionList"></ziro-textarea>
<ziro-checkbox fieldId="legalHold"></ziro-checkbox>
<ng-template #errorTemplate>
  @if (!isAlertHidden()) {
    <span>{{ 'tkey;validators.global.required.missing.error' | translate }}</span>
  }
</ng-template>
